import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

class CustomDateFnsUtils extends DateFnsUtils {
  date(value?: any): Date {
    return moment.utc(value).toDate();
  }
}

export default CustomDateFnsUtils;
